import {
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomInput,
  CustomMaskInput,
  CustomSelect,
  CustomTextInput,
  Option,
  Text,
  useText,
} from '@src/components';
import { cardTypeIcon } from '@src/utils/utils';
import { useDispatch } from 'react-redux';
import { monthsList, creditCardYears } from '@src/store/enums';
import React, { useCallback, useEffect, useState } from 'react';
import { formCreditCardRegex } from '@src/utils/formRule';
import { getBankOfBinNumber, setPayWithLinkinEmail } from '@src/store/slice/mobilExpressSlice';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import PropTypes from 'prop-types';
import CustomCheckbox from '@src/components/CustomCheckbox';

const NewCreditCards = ({
  form,
  setPayLater = () => {},
  setCounter = () => {},
  propIsOn = false,
}) => {
  const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });
  const [cardTypeImage, setCardTypeImage] = React.useState(false);
  const dispatch = useDispatch();
  const [isStoreCard, setIsStoreCard] = useState(false);
  const [isOn, setIsOn] = useState(false);

  const nameOnCard = useText('nameOnCard');
  const pleaseEnterNameOnCard = useText('pleaseEnterNameOnCard');
  const cardNumberText = useText('cardNumber2');
  const monthText = useText('month2');
  const yearText = useText('year2');
  const yes2Text = useText('yes2');
  const no2Text = useText('no2');

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };

  useEffect(() => {
    if (isOn !== propIsOn) setIsOn(propIsOn);
  }, [propIsOn]);

  useEffect(() => {
    if (isOn) setPayLater(isOn);
    console.log('isOn', isOn);
  }, [isOn]);

  function handleSaveCardChecked(e) {
    setIsStoreCard(e.target.checked);
    dispatch(setPayWithLinkinEmail(false));
  }

  const cardNumberChange = useCallback(
    async (value) => {
      const cardNumber = value.replaceAll('_', '').replaceAll('-', '');
      if (cardNumber.length === 6) {
        const body = {
          bin: cardNumber,
        };
        const action = await dispatch(getBankOfBinNumber(body));
        if (getBankOfBinNumber.fulfilled.match(action)) {
          setCardTypeImage(cardTypeIcon(action.payload.data?.cardType));
        }
      }
    },
    [dispatch],
  );

  return (
    <div>
      <div className="new-credit-card-content" data-testid="new-credit-card-div">
        <CustomForm
          name="creditCardForm"
          className="credit-card-form"
          initialValues={{
            cardSaveChecked: false,
          }}
          autoComplete="off"
          layout={'vertical'}
          form={form}
        >
          <div className="row">
            <div className="col-lg-6">
              <CustomFormItem
                label={<Text t="nameOnCard" />}
                name="cardHolderName"
                rules={[{ required: true, message: pleaseEnterNameOnCard }]}
              >
                <CustomTextInput
                  id="ticketRestaurant-balanceUpload-payment-newCreditCards-cardHolderName-textInput"
                  onInput={() => setCounter((count) => count + 1)}
                  placeholder={nameOnCard}
                />
              </CustomFormItem>
            </div>
            <div className="col-lg-6">
              <CustomFormItem
                label={cardNumberText}
                name="cardNumber"
                className="card-number-form-item"
                rules={[
                  { required: true, message: <Text t="pleaseEnterCardNumber" /> },
                  {
                    validator: formCreditCardRegex,
                    message: <Text t="pleaseEnterAValidCardNumber" />,
                  },
                  {
                    validator: async (field, value) => {
                      setCounter((count) => count + 1);
                      return Promise.resolve();
                    },
                    message: '',
                  },
                ]}
              >
                <CardInput
                  id="ticketRestaurant-balanceUpload-payment-newCreditCards-cardNumber-cardInput"
                  onInput={() => setCounter((count) => count + 1)}
                  cardTypeImage={cardTypeImage}
                  cardNumberChange={cardNumberChange}
                />
              </CustomFormItem>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <CustomFormItem
                name={'expireMonthYear'}
                className="expire-form-item"
                label={
                  <span>
                    <Text t="expirationDate" />
                    <span className="form-required-mark">*</span>
                  </span>
                }
              >
                <div className="row">
                  <div className="ant-col-xs-12" style={isMobil ? { padding: '0 10px 0 0' } : null}>
                    <CustomFormItem
                      label={false}
                      name="lastMonth"
                      rules={[{ required: true, message: <Text t="requiredField2" /> }]}
                    >
                      <CustomSelect
                        id="ticketRestaurant-balanceUpload-payment-newCreditCards-lastMonth-select"
                        onChange={() => setCounter((count) => count + 1)}
                        placeholder={monthText}
                      >
                        {monthsList.map((month) => (
                          <Option
                            id={`ticketRestaurant-balanceUpload-payment-newCreditCards-lastMonth-${month?.value}-select`}
                            key={month.value}
                            value={month.value}
                          >
                            {month.value}
                          </Option>
                        ))}
                      </CustomSelect>
                    </CustomFormItem>
                  </div>

                  <div className="ant-col-xs-12" style={isMobil ? { padding: '0 10px 0 0' } : null}>
                    <CustomFormItem
                      label={false}
                      name="lastYear"
                      rules={[{ required: true, message: <Text t="requiredField2" /> }]}
                    >
                      <CustomSelect
                        id="ticketRestaurant-balanceUpload-payment-newCreditCards-lastYear-select"
                        onChange={() => setCounter((count) => count + 1)}
                        placeholder={yearText}
                      >
                        {creditCardYears.map((year) => (
                          <Option
                            id={`ticketRestaurant-balanceUpload-payment-newCreditCards-lastYear-${year.value}-select`}
                            key={year.value}
                            value={year.value}
                          >
                            {year.value}
                          </Option>
                        ))}
                      </CustomSelect>
                    </CustomFormItem>
                  </div>
                </div>
              </CustomFormItem>
            </div>
            <div className="col-lg-6">
              <CustomFormItem
                label={
                  <span>
                    <Text t="securityCode" />
                    <span className="form-required-mark">*</span>{' '}
                  </span>
                }
                name="cvv"
                className="cvv-form-item"
                rules={[
                  {
                    validator: async (field, val) => {
                      const value = val?.replace('_', '').split('');
                      try {
                        setCounter((count) => count + 1);
                        if (value.length === 3) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error());
                      } catch (e) {
                        return Promise.reject(new Error());
                      }
                    },
                    message: <Text t="pleaseEnterTheSecurityCodeOnTheCard" />,
                  },
                ]}
              >
                <CustomMaskInput
                  id="ticketRestaurant-balanceUpload-payment-newCreditCards-cvv-maskInput"
                  mask={'999'}
                >
                  <CustomInput
                    id="ticketRestaurant-balanceUpload-payment-newCreditCards-cvv-input"
                    placeholder="CVC / CVV"
                  />
                </CustomMaskInput>
              </CustomFormItem>
            </div>
          </div>

          <div className="info-text-contain">
            <div className="col-md-12">
              <CustomFormItem label={false} name="cardSaveChecked" valuePropName="checked">
                <CustomCheckbox
                  id="ticketRestaurant-balanceUpload-payment-newCreditCards-cardSaveChecked-checkbox"
                  value={isStoreCard}
                  onChange={handleSaveCardChecked}
                >
                  <span className="info-text-title">
                    <Text t="saveMyCardInformationWithMobileExpressSecurity" />
                  </span>
                </CustomCheckbox>
              </CustomFormItem>
            </div>
          </div>
        </CustomForm>
      </div>

      <div
        className="vehicle-managemet-add-fleet-limit-new-card-later"
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 10,
          alignItems: 'center',
          fontSize: 14,
          fontWeight: 'normal',
          color: '#1d2228',
          textAlign: 'left',
        }}
      >
        <Text t="iWantToCompleteMyPaymentLaterWith" />
        <button style={{ backgroundColor: 'transparent', borderWidth: 0 }} onClick={toggleSwitch}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: isOn ? 'flex-end' : 'flex-start',
              width: '100px',
              height: '40px',
              backgroundColor: isOn ? '#f66301' : '#ccc',
              borderRadius: '20px',
              cursor: 'pointer',
              padding: '5px',
              transition: 'all 0.3s ease',
            }}
          >
            {!isOn && (
              <div
                style={{
                  width: '30px',
                  height: '30px',
                  backgroundColor: '#fff',
                  borderRadius: '50%',
                  boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                }}
              />
            )}
            <span
              style={{
                marginLeft: 10,
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '12px',
                flex: 1,
              }}
            >
              {isOn ? yes2Text : no2Text}
            </span>
            {isOn && (
              <div
                style={{
                  width: '30px',
                  height: '30px',
                  backgroundColor: '#fff',
                  borderRadius: '50%',
                  boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                }}
              />
            )}
          </div>
        </button>
      </div>
    </div>
  );
};

NewCreditCards.propTypes = {
  form: PropTypes.any,
  setPayLater: PropTypes.func,
  setCounter: PropTypes.func,
  propIsOn: PropTypes.bool,
};

export default NewCreditCards;

const CardInput = ({ cardTypeImage, cardNumberChange, onChange, ...props }) => {
  const enterYour16DigitCardNumber = useText('enterYour16DigitCardNumber');
  const change = (e) => {
    cardNumberChange?.(e.target.value);
    onChange?.(e);
  };

  return (
    <CustomMaskInput
      id="companyInformation-creditCards-newCreditCard-creditCardForm-card-maskInput"
      {...props}
      mask={'9999-9999-9999-9999'}
      onChange={change}
    >
      <CustomInput
        id="companyInformation-creditCards-newCreditCard-creditCardForm-card-input"
        placeholder={enterYour16DigitCardNumber}
        suffix={cardTypeImage ? <CustomImage src={cardTypeImage} /> : <span />}
      />
    </CustomMaskInput>
  );
};
